import React from 'react';

export const Footer = () => {
    return (
          <footer className="page-footer" >
                End To End Management &copy; 2021
          </footer>  
    )
}
